import { buttomBtnInit } from "./functions.js";

document.addEventListener("DOMContentLoaded", function (event) {
  buttomBtnInit();

  const goTopBtn = document.querySelector("#upBtn");

  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      goTopBtn.style.opacity = 1;
      goTopBtn.style.visibility = "visible";
    } else {
      goTopBtn.style.opacity = 0;
      goTopBtn.style.visibility = "hidden";
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  goTopBtn.addEventListener("click", topFunction);
});
